import React from 'react';

import { withFirebase } from '../Firebase';


const SignOutButtonSmall = ({ firebase }) => (
  <a href="/#Home" className="mini-nav-btn" onClick={firebase.doSignOut}>Sign Out</a>
);
  
export default withFirebase(SignOutButtonSmall);